import { render, staticRenderFns } from "./YouZanList.vue?vue&type=template&id=272db69c&"
import script from "./YouZanList.vue?vue&type=script&lang=js&"
export * from "./YouZanList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports